module.exports = __webpack_public_path__ + "img/apple-pay.95b25dbd.png";